import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useDeepActionOrgId = () => {
  const location = useLocation();

  const deepActionOrgId = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    const orgId = searchParams.get('org_id');
    const callbackUri = searchParams.get('callback_uri');

    if (callbackUri && orgId) {
      return orgId;
    }
    return null;
  }, [location.search]);

  return {
    deepActionOrgId,
  };
};

export { useDeepActionOrgId };
